import { columns } from './columns';
import { filters } from './filters';
import { query } from './query';

const maintenanceHistoryConfig = {
    columns,
    filters,
    queryFilter: query,
};

export default maintenanceHistoryConfig;
